import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingVertical: 6,
    flex: 1,
  },
  itemLeft: {
    flex: 1,
    alignItems: 'flex-start',
  },
   itemRight: {
    flex: 1,
    alignItems: 'flex-end',
    marginRight: 12,
  },
  itemSeparator: {
    width: 1,
    backgroundColor: PALETTE.secondaryText,
    marginVertical: 8,
    marginHorizontal: 20,
  },
  itemLabel: {
    color: PALETTE.secondaryText,
  },
  itemValueBlank: {
    color: PALETTE.secondaryText,
  },
  marginValue: {
    marginTop: 10,
  },
});
